import Model            from "../../Lib/Model";
import PalettesResource from "./PalettesResource";
import Swatch           from "./Swatch";

export default class Palette extends Model {

    getSwatches() {
        return Swatch.makeArray(this.swatches);
    }

    update() {
        return Palette.resource.update(this.id, this);
    }

    static get resource() {
        return new PalettesResource();
    }

}
